import './CSAE.css';

function CSAE() {
  return (
    <div className="csae">
      <section className="csae-hero">
        <div className="csae-hero-img">
          <img src="/assets/hero_img.png" alt="Hero Image" />
        </div>
        <div className="container">
          <h1>Safety & Protection</h1>
          <p className="hero-subtitle">Child Sexual Abuse and Exploitation Prevention Policy</p>
          <p className="last-updated">Last updated: July 7, 2025</p>
        </div>
      </section>

      <section className="csae-content">
        <div className="container">
          <div className="policy-section">
            <h2>Our Commitment</h2>
            <p>
              Small Robot LLC is committed to preventing the exploitation and abuse of minors on our platform.
              This policy outlines our approach to protecting minors and preventing the distribution
              of CSAE content.
            </p>
          </div>

          <div className="policy-section">
            <h2>Age Requirements</h2>
            <ul>
              <li>Users must be 18 years or older to use our applications</li>
              <li>Age verification is required during registration</li>
              <li>Accounts suspected of being operated by minors will be immediately suspended pending verification</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Prohibited Content and Behavior</h2>
            <p>The following are strictly prohibited and will result in immediate account termination:</p>
            <ul>
              <li>Any content involving minors in sexual contexts</li>
              <li>Sexualized images or videos of minors</li>
              <li>Content that exploits or abuses minors</li>
              <li>Grooming behavior or attempts to contact minors</li>
              <li>Content that suggests or promotes the exploitation of minors</li>
              <li>Sharing or requesting CSAE content</li>
              <li>Any attempt to circumvent our age verification systems</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>User Reporting</h2>
            <p>Users can report suspicious content or behavior through:</p>
            <ul>
              <li>In-app reporting buttons</li>
              <li>Email: <a href="mailto:support@smallrobot.app">support@smallrobot.app</a></li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Our Response</h2>
            <ol>
              <li>Immediate content removal upon report</li>
              <li>Account suspension during investigation</li>
              <li>Permanent account termination if violations are confirmed</li>
              <li>Cooperation with law enforcement when required</li>
              <li>Reporting to NCMEC (National Center for Missing and Exploited Children) as required by law</li>
            </ol>
          </div>

          <div className="policy-section">
            <h2>Prevention Measures</h2>
            <ol>
              <li>Automated content scanning</li>
              <li>User verification systems</li>
              <li>Age verification at registration</li>
              <li>Regular account audits</li>
              <li>Staff training on CSAE prevention</li>
              <li>Partnership with safety organizations</li>
            </ol>
          </div>

          <div className="policy-section">
            <h2>Legal Compliance</h2>
            <ul>
              <li>We comply with all applicable laws regarding CSAE prevention</li>
              <li>We cooperate with law enforcement investigations</li>
              <li>We maintain records as required by law</li>
              <li>We report incidents to relevant authorities</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Platform Safety Features</h2>
            <ol>
              <li>User blocking capabilities</li>
              <li>Privacy controls</li>
              <li>Content moderation</li>
              <li>Report tracking system</li>
              <li>Safety team monitoring</li>
            </ol>
          </div>

          <div className="policy-section">
            <h2>Updates and Reviews</h2>
            <ul>
              <li>This policy is reviewed quarterly</li>
              <li>Updates are communicated to users</li>
              <li>Annual safety audits are conducted</li>
              <li>Staff training is updated regularly</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Enforcement</h2>
            <p>We maintain zero tolerance for CSAE violations. Any violation results in:</p>
            <ol>
              <li>Immediate account termination</li>
              <li>Content removal</li>
              <li>Law enforcement notification</li>
              <li>Permanent platform ban</li>
              <li>Legal action when applicable</li>
            </ol>
          </div>

          <div className="policy-section">
            <h2>Contact Information</h2>
            <p>For questions about this policy or to report violations:</p>
            <ul>
              <li>Email: <a href="mailto:support@smallrobot.app">support@smallrobot.app</a></li>
              <li>In-app reporting tools</li>
              <li>Emergency contact: [Emergency Contact Number]</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CSAE;